import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeTypeDocs = async ({ docId, typeId }) => {
  return await request.put(
    `/Docs/type/${docId}?typeId=${typeId}`,
    null,
    'При изменении типа документа произошла ошибка',
    'Error'
  );
};

const useChangeTypeDocs = () =>
  useMutation(changeTypeDocs, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

export default useChangeTypeDocs;
